module.exports = __webpack_public_path__ + "img/palette-1_fg_cn.4a9aed0.jpg";